import { Flex, Text, Grid, GridItem, Image, Box } from '@chakra-ui/react';
import MyDiv from './payrollHeader.style'
import EmployeesPaidIcon from '../../../../assets/images/EmployeesPaidIcon.png';
import PayoutAmountIcon from '../../../../assets/images/PayoutAmountIcon.svg';
import { IStatusCount } from '../PayrollList/modal';

const PayrollHeader = ({ totalRecords, statusCount }: { totalRecords: number, statusCount: IStatusCount[] }) => {
  const cards = [
    { Heading: "Payroll Processed", description: "90% payroll Processed For this month", isFirstCard: true},
    { label: "Pending Payrolls", icon:PayoutAmountIcon , count: statusCount.find(f => f.status === 'pending')?.count ?? 0 },
    { label: "Generated Payrolls", icon: EmployeesPaidIcon, count: statusCount.find(f => f.status === 'generated')?.count ?? 0 },
    { label: "Updated Payrolls", icon: EmployeesPaidIcon, count: statusCount.find(f => f.status === 'updated')?.count ?? 0 },
    { label: "Released Payrolls", icon: EmployeesPaidIcon, count: statusCount.find(f => f.status === 'released')?.count ?? 0 }
  ];

  return (
    <MyDiv>
      <Grid className="headerGrid" gridColumnGap={6}>
        {cards.map((card, index) => (
          <GridItem key={index} colSpan={{ base: 10, sm: 5, md: 3, lg: 2 }} className="card_box">
            {card.isFirstCard ? (
              <>
                <Text className="headings">{card.Heading}</Text>
                <Flex align="center" mt={2}>
                  <Box w="10px" h="10px" borderRadius="full" bg="green" mr={2} />
                  <Text className="txt">
                    {statusCount.find(s => s.status !== 'pending')?.count ?? 0} <Text as={"span"} className="highlight">Payroll Processed</Text>
                  </Text>
                </Flex>
                <Flex align="center" mt={2}>
                  <Box w="10px" h="10px" borderRadius="full" bg="gray.500" mr={2} />
                  <Text className="txt">
                    {statusCount.find(s => s.status === 'pending')?.count ?? 0} <Text as={"span"} className="highlight">Pending Processed</Text>
                  </Text>
                </Flex>
                <Text className="caption" mt={3}>
                  {statusCount.find(s => s.status !== 'pending')?.count ? `${statusCount.find(s => s.status !== 'pending')?.count ?? 0 * 100 / totalRecords}` : 0}% payroll Processed For this month
                </Text>
              </>
            ) : (
              <>
                <Flex align="center" gap={3} mb={3}>
                  <Image src={card.icon} className="card_icon" alt={card.label} />
                  <Text className="card_label">{card.label}</Text>
                </Flex>
                <Text className="card_value">{card.count}</Text>
              </>
            )}
          </GridItem>
        ))}
      </Grid>
    </MyDiv>
  );
};

export default PayrollHeader;